/**
 * Footer's footer_column blocks (sections/footer.liquid) render as native
 * <details> - an accordion on mobile with only the first column open, but
 * always fully expanded on desktop where the accordion click is disabled
 * (pointer-events: none on the summary). A closed <details> hides its
 * content in an internal UA shadow slot that plain CSS can't override, so
 * the `open` attribute has to be toggled for real when crossing the
 * desktop breakpoint.
 */
function initFooterColumnAccordion() {
  const columns = document.querySelectorAll('.site-footer__column');
  if (!columns.length) return;

  columns.forEach((details) => {
    details.dataset.mobileOpen = details.open ? 'true' : 'false';
  });

  const desktopQuery = window.matchMedia('(min-width: 750px)');

  function sync() {
    columns.forEach((details) => {
      details.open = desktopQuery.matches || details.dataset.mobileOpen === 'true';
    });
  }

  sync();
  desktopQuery.addEventListener('change', sync);
  window.addEventListener('resize', sync);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFooterColumnAccordion);
} else {
  initFooterColumnAccordion();
}
